import { Locale } from '../../i18n';

export const authGuardTranslation = {
  [Locale.en]: {
    title: 'Sign in to your account<br /> to continue with {project}',
  },
};
